import React from 'react'

import PropTypes from 'prop-types'

import { StyledHeadline } from './styled'

const Headline = ({ level, titleHtml, titleText, ...props }) => {
  const headlineLevel = `h${level}`

  if (titleHtml) {
    return (
      <StyledHeadline
        as={headlineLevel}
        dangerouslySetInnerHTML={{ __html: titleHtml }}
        {...props}
      />
    )
  }

  return (
    <StyledHeadline as={headlineLevel} {...props}>
      {titleText}
    </StyledHeadline>
  )
}

Headline.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  titleHtml: PropTypes.string,
  titleText: PropTypes.string
}

Headline.defaultProps = {
  level: 2,
  titleHtml: '',
  titleText: ''
}

export default Headline
